import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import ProductImageTile from "@/components/ProductImageTile";

export default function CollectionDetail() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  useEffect(() => { api.get(`/collections/${slug}`).then(r => setData(r.data)).catch(() => setData({error:true})); }, [slug]);
  if (!data) return <div className="pt-40 text-center text-ink/50">Loading…</div>;
  if (data.error) return <div className="pt-40 text-center">Collection not found</div>;
  const { collection, products } = data;
  return (
    <div className="bg-ivory text-ink">
      <section className="relative h-[70vh] overflow-hidden">
        <img src={collection.hero_image} alt="" className="absolute inset-0 w-full h-full object-cover animate-slow-zoom" />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-ivory" />
        <div className="grain" />
        <div className="relative h-full flex flex-col items-center justify-center text-center px-8 pt-24 text-ivory">
          <p className="text-[10px] tracking-luxury uppercase text-gold mb-4">Chapter {collection.chapter_roman}</p>
          <h1 className="font-editorial text-6xl md:text-9xl leading-[0.9] tracking-tight">{collection.name}</h1>
          <p className="mt-4 font-editorial-italic text-2xl md:text-3xl text-ivory/85">{collection.tagline}</p>
        </div>
      </section>
      <section className="max-w-3xl mx-auto text-center px-8 py-20">
        <p className="font-editorial text-2xl md:text-3xl leading-relaxed text-ink/80">{collection.description}</p>
      </section>
      <section className="max-w-[1400px] mx-auto px-8 md:px-16 pb-24">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-16">
          {products.map((p, i) => (
            <Link key={p.id} to={`/product/${p.slug}`} data-testid={`collection-product-${p.slug}`} className="group animate-fade-up" style={{ animationDelay: `${i*60}ms` }}>
              <ProductImageTile src={p.images[0]} hoverSrcs={p.images.slice(1)} alt={p.name} />
              <div className="mt-6">
                <p className="text-[10px] tracking-widest-plus uppercase text-gold mb-2">Chapter {p.chapter_roman}</p>
                <p className="font-editorial text-xl">{p.name}</p>
                <p className="mt-1 text-[10px] tracking-widest-plus uppercase text-ink/50">
                  {p.availability === "in_store" ? "In boutique" : p.availability === "pre_order" ? "Pre-order" : "Enquire"}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
